import React, { useCallback, useReducer, useState } from "react"
import { buscarPedidosFiltrados } from "../../../services/dadosPedidoFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { DadosPedidoFornecedorInicial } from "../models/dadosPedidoFornecedorModel"
import { DadosPedidoFornecedorActionsTypes } from "./dadosPedidoFornecedorActions"
import { DadosPedidoFornecedorContext } from "./DadosPedidoFornecedorContext"
import { dadosPedidoFornecedorReducer } from "./dadosPedidoFornecedorReducer"

export function DadosPedidoFornecedorContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(dadosPedidoFornecedorReducer, DadosPedidoFornecedorInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const pesquisar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            setErroCarregamento(null)
            const response = await buscarPedidosFiltrados(autorizacao, dados.filtro)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao buscar pedidos")
            } else {
                dispatch({
                    type: DadosPedidoFornecedorActionsTypes.CARREGAR_RESULTADO,
                    payload: response,
                })
            }
        } catch {
            setErroCarregamento("Erro ao buscar pedidos")
        } finally {
            setLoading(false)
        }
    }, [dados.filtro])

    return (
        <DadosPedidoFornecedorContext.Provider
            value={{ dados, dispatch, pesquisar, erroCarregamento }}
        >
            <Loading />
            {children}
        </DadosPedidoFornecedorContext.Provider>
    )
}
